(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-a-box-main"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var productSwiper = new Swiper('.products-slider', {
      slidesPerView: 1,
      spaceBetween: 50,
      loop: true,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 100,
        },
      },
    });
    var testimonialSwiper = new Swiper('.build-testimonials', {
      slidesPerView: 1,
      spaceBetween: 50,
      loop: true,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 100,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-gift-main-new"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const giftCheckbox = document.querySelector('#gift-purchase');
  const giftFormContainer = document.querySelector('.gift-form-container');
  const giftSeasonInputs = document.querySelectorAll('input[name="gift-seasons"]');

  function updateGiftPricing() {
    if (!giftFormContainer) {
      return;
    }
    
    if (!productConfigs.gift) {
      return;
    }
    
    // Get the one-season base price for strikethrough calculations
    const oneSeasonPrice = parseFloat(productConfigs.gift['1'].price);
    
    // Update 1 Season pricing
    const price1 = parseFloat(productConfigs.gift['1'].price);
    const giftPrice1 = document.querySelector('.gift-price-1');
    if (giftPrice1) {
      giftPrice1.innerHTML = '<strong>$' + Math.round(price1) + '/box</strong>';
    }
    
    // Update 2 Seasons pricing
    const price2 = parseFloat(productConfigs.gift['2'].price);
    const strikethrough2 = Math.round(oneSeasonPrice * 2);
    const giftStrikethrough2 = document.querySelector('.gift-strikethrough-2');
    const giftPrice2 = document.querySelector('.gift-price-2');
    const giftPerBox2 = document.querySelector('.gift-per-box-2');
    if (giftStrikethrough2) giftStrikethrough2.innerHTML = '$' + strikethrough2;
    if (giftPrice2) giftPrice2.innerHTML = '<strong>$' + Math.round(price2) + '</strong>';
    if (giftPerBox2) giftPerBox2.innerHTML = ' ($' + (price2 / 2).toFixed(2) + '/box)';
    
    // Update 3 Seasons pricing
    const price3 = parseFloat(productConfigs.gift['3'].price);
    const strikethrough3 = Math.round(oneSeasonPrice * 3);
    const giftStrikethrough3 = document.querySelector('.gift-strikethrough-3');
    const giftPrice3 = document.querySelector('.gift-price-3');
    const giftPerBox3 = document.querySelector('.gift-per-box-3');
    if (giftStrikethrough3) giftStrikethrough3.innerHTML = '$' + strikethrough3;
    if (giftPrice3) giftPrice3.innerHTML = '<strong>$' + Math.round(price3) + '</strong>';
    if (giftPerBox3) giftPerBox3.innerHTML = ' ($' + (price3 / 3).toFixed(2) + '/box)';
    
    // Update 4 Seasons pricing
    const price4 = parseFloat(productConfigs.gift['4'].price);
    const strikethrough4 = Math.round(oneSeasonPrice * 4);
    const giftStrikethrough4 = document.querySelector('.gift-strikethrough-4');
    const giftPrice4 = document.querySelector('.gift-price-4');
    const giftPerBox4 = document.querySelector('.gift-per-box-4');
    if (giftStrikethrough4) giftStrikethrough4.innerHTML = '$' + strikethrough4;
    if (giftPrice4) giftPrice4.innerHTML = '<strong>$' + Math.round(price4) + '</strong>';
    if (giftPerBox4) giftPerBox4.innerHTML = ' ($' + (price4 / 4).toFixed(2) + '/box)';
  }

  function updateGiftFormVisibility() {
    const checkoutButton = document.querySelector('#main-checkout-btn');
    
    if (!giftCheckbox || !giftFormContainer) {
      return;
    }
    
    if (giftCheckbox.checked) {
      giftFormContainer.classList.add('show');
      // checkoutButton.setAttribute('data-type', 'gift-card');
      const selectedGift = document.querySelector('input[name="gift-seasons"]:checked');
      if (selectedGift) {
        checkoutButton.setAttribute('data-gift-seasons', selectedGift.value);
      }
    } else {
      giftFormContainer.classList.remove('show');
      checkoutButton.removeAttribute('data-type');
      checkoutButton.removeAttribute('data-gift-seasons');
    }
  }

  function showFieldError(inputEl, message) {
    const field = inputEl.closest('.form-field');
    if (!field) return;
    field.classList.add('error');
    let error = field.querySelector('.error-text');
    if (!error) {
      error = document.createElement('div');
      error.className = 'error-text';
      field.appendChild(error);
    }
    error.textContent = message;
  }

  function clearFieldError(inputEl) {
    const field = inputEl.closest('.form-field');
    if (!field) return;
    field.classList.remove('error');
    const error = field.querySelector('.error-text');
    if (error) error.remove();
  }

  function clearGiftErrors() {
    // No required fields to clear errors for
  }

  function validateGiftForm() {
    // No required fields to validate - message is optional
    return true;
  }

  // Live-clear errors as user types
  ['message'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', () => clearFieldError(el));
    }
  });

  function updateCheckoutButton() {
    const selectedGift = document.querySelector('input[name="gift-seasons"]:checked');
    const selectedGiftKey = selectedGift ? selectedGift.value : '1';
    
    let config;
    if (productConfigs.gift && productConfigs.gift[selectedGiftKey]) {
      config = productConfigs.gift[selectedGiftKey];
      checkoutButton.setAttribute('data-variant-id', config.variantId);
      if (config.sellingPlanId) {
        checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);
      } else {
        checkoutButton.removeAttribute('data-selling-plan-id');
      }
      checkoutButton.setAttribute('data-qty', '1');
    } else {
      return;
    }

    const price = config.price;
    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = showPriceInCta ? `${ctaText} - $${price} ${lockIcon}` : ctaText;
  }

  if (giftSeasonInputs.length > 0) {
    giftSeasonInputs.forEach((input) => {
      input.addEventListener('change', () => {
        updateCheckoutButton();
        if (giftCheckbox && giftCheckbox.checked) {
          checkoutButton.setAttribute('data-gift-seasons', input.value);
        }
      });
    });
  }

  if (giftCheckbox) {
    giftCheckbox.addEventListener('change', () => {
      updateGiftFormVisibility();
      updateCheckoutButton();
      if (!giftCheckbox.checked) {
        clearGiftErrors();
      }
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight + 250)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 250) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();
  updateGiftFormVisibility();
  updateGiftPricing();

  // Intercept checkout click to validate gift form when gift purchase is selected
  if (checkoutButton) {
    checkoutButton.addEventListener('click', (e) => {
      if (giftCheckbox && giftCheckbox.checked) {
        if (!validateGiftForm()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          const form = document.querySelector('.gift-form-container');
          if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      }
      return true;
    });
  }

  // Capture-phase guard to block any other listeners from adding to cart
  document.addEventListener('click', (e) => {
    const btn = e.target && (e.target.closest && e.target.closest('#main-checkout-btn'));
    if (!btn) return;
    if (giftCheckbox && giftCheckbox.checked && !validateGiftForm()) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const form = document.querySelector('.gift-form-container');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  function toggleAccordion(button) {
    const accordionItem = button.parentElement;
    const isActive = accordionItem.classList.contains('active');
    
    // Close all accordion items
    document.querySelectorAll('.accordion-item').forEach(item => {
      item.classList.remove('active');
    });
    
    // If this item wasn't active, open it
    if (!isActive) {
      accordionItem.classList.add('active');
    }
  }

  // Make toggleAccordion globally available
  window.toggleAccordion = toggleAccordion;

  const modal = document.getElementById('modal');
  const modalBody = document.getElementById('modal-body');
  const modalBtn = document.getElementById('open-modal');
  const closeModal = document.getElementById('close-button');

  if (modalBtn && modal && modalBody) {
    modalBtn.addEventListener('click', () => {
      modalBody.innerHTML = `
        <div class="loader"></div>
        <p style="text-align:center;">Loading content...</p>
      `;
      modal.style.display = "block";
      
      fetch(nowShippingModalLink)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const targetDiv = doc.querySelector('main.main-content');

          modalBody.innerHTML = targetDiv ? targetDiv.innerHTML : "<p style='text-align:center;'>Content not found</p>";
        })
        .catch(() => {
          modalBody.innerHTML = "<p style='color:red; text-align:center;'>Failed to load content.</p>";
        })
    });

    if (closeModal) {
      closeModal.addEventListener('click', () => {
        modal.style.display = 'none';
      });
    }

    window.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-gift-main-plus"]) return;
  try {
    
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6,
      },
    },
  });
  var swiper2 = new Swiper('.swiper-main', {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const planInputs = document.querySelectorAll('input[name="box-frequency"]');
  const selectedBoxType = 'plus'; // Hardcoded to 'plus' for this page

  function updateCheckoutButton() {
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const onePrice = document.querySelector('.frequency input[type="radio"]#one + label .price');
    const twoPrice = document.querySelector('.frequency input[type="radio"]#two + label .price');
    const threePrice = document.querySelector('.frequency input[type="radio"]#three + label .price');
    const fourPrice = document.querySelector('.frequency input[type="radio"]#four + label .price');
    // const savings2 = document.querySelector('.frequency input[type="radio"]#two + label .savings');
    // const savings3 = document.querySelector('.frequency input[type="radio"]#three + label .savings');
    const savings4 = document.querySelector('.frequency input[type="radio"]#four + label .savings');
    // const billedAnnually = document.querySelector('.frequency input[type="radio"]#four + label .billed-annually')

    const config = productConfigs[selectedBoxType][selectedFrequency];
    console.log(config);
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    onePrice.innerHTML = '$' + productConfigs[selectedBoxType].one.price + '<span> / box</span>';
    twoPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].two.price / 2.00).toFixed(2) + '<span> / box</span>';
    threePrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].three.price / 3.00).toFixed(2) + '<span> / box</span>';
    fourPrice.innerHTML =
      '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.0).toFixed(2) + '<span> / box</span>';
    // billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' annually.';
    // savings2.innerText =
    //   '. Save $' + (productConfigs[selectedBoxType].one.price * 2 - productConfigs[selectedBoxType].two.price);
    // savings3.innerText =
    //   '. Save$' + (productConfigs[selectedBoxType].one.price * 3 - productConfigs[selectedBoxType].three.price);
    savings4.innerText =
      '$' + (productConfigs[selectedBoxType].one.price * 4 - productConfigs[selectedBoxType].four.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    const buttonText = giftCtaText || ctaText;
    checkoutButton.innerHTML = showPriceInCta ? `${buttonText} - $${price} ${lockIcon}` : buttonText;

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (
      !checkoutButton.classList.contains('is-sticky') &&
      window.scrollY > checkoutButton.offsetTop + checkoutButton.offsetHeight
    ) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', updateButtonPosition);

  updateButtonPosition();
  updateCheckoutButton();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-gift-main-popups"]) return;
  try {
    
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6,
      },
    },
  });
  var swiper2 = new Swiper('.swiper-main', {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="box-frequency"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const onePrice = document.querySelector('.frequency input[type="radio"]#one + label .price');
    const fourPrice = document.querySelector('.frequency input[type="radio"]#four + label .price');
    const savings = document.querySelector('.frequency input[type="radio"]#four + label .savings');
    // const billedAnnually = document.querySelector('.frequency input[type="radio"]#four + label .billed-annually')

    const config = productConfigs[selectedBoxType][selectedFrequency];
    console.log(config);
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    onePrice.innerHTML = '$' + productConfigs[selectedBoxType].one.price + '<span> / box</span>';
    fourPrice.innerHTML =
      '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.0).toFixed(2) + '<span> / box</span>';
    // billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].one.price * 4 - productConfigs[selectedBoxType].four.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `Add to Cart - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (
      !checkoutButton.classList.contains('is-sticky') &&
      window.scrollY > checkoutButton.offsetTop + checkoutButton.offsetHeight
    ) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', updateButtonPosition);

  updateButtonPosition();
  updateCheckoutButton();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-gift-main"]) return;
  try {
    
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6,
      },
    },
  });
  var swiper2 = new Swiper('.swiper-main', {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="box-frequency"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const onePrice = document.querySelector('.frequency input[type="radio"]#one + label .price');
    const fourPrice = document.querySelector('.frequency input[type="radio"]#four + label .price');
    const savings = document.querySelector('.frequency input[type="radio"]#four + label .savings');
    // const billedAnnually = document.querySelector('.frequency input[type="radio"]#four + label .billed-annually')

    const config = productConfigs[selectedBoxType][selectedFrequency];
    console.log(config);
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    onePrice.innerHTML = '$' + productConfigs[selectedBoxType].one.price + '<span> / box</span>';
    fourPrice.innerHTML =
      '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.0).toFixed(2) + '<span> / box</span>';
    // billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].one.price * 4 - productConfigs[selectedBoxType].four.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `Add to Cart - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (
      !checkoutButton.classList.contains('is-sticky') &&
      window.scrollY > checkoutButton.offsetTop + checkoutButton.offsetHeight
    ) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', updateButtonPosition);

  updateButtonPosition();
  updateCheckoutButton();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-consolidated-main"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const frequencyInputs = document.querySelectorAll('input[name="box-frequency"]');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually');
    const planTitles = document.querySelectorAll('.plan input[type="radio"] + label .plan-title');
    const planDescriptions = document.querySelectorAll('.plan input[type="radio"] + label .plan-description');
    const seasonalBilling = document.querySelector('.plan input[type="radio"]#seasonal + label p:not(.plan-description)');

    // Update plan labels based on frequency
    if (selectedFrequency === 'onetime') {
      planTitles[0].textContent = '4 Boxes';
      planTitles[1].textContent = 'Single Box';
      planDescriptions[0].textContent = 'Prepay for 4 boxes';
      planDescriptions[1].textContent = 'One-time purchase';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed once.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed once.';
      }
    } else {
      planTitles[0].textContent = 'Annual';
      planTitles[1].textContent = 'Seasonal';
      planDescriptions[0].textContent = 'Prepay for 4 boxes & save';
      planDescriptions[1].textContent = 'Pay Per box';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed annually.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed quarterly.';
      }
    }

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    if (selectedBoxType == 'regular') {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      });
    } else {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      });
    }
    
    var consolidatedPlan = selectedPlan;
    if (selectedFrequency === 'onetime') {
      if (selectedPlan === 'seasonal') {
        consolidatedPlan = 'single'
      } else {
        consolidatedPlan = 'four'
      }
    } else {
      consolidatedPlan = selectedPlan;
    }

    const config = productConfigs[selectedBoxType][consolidatedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    if (selectedFrequency === 'onetime') {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].single.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' once.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].single.price * 4 - productConfigs[selectedBoxType].four.price);
      }
    } else {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);
      }
    }

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    frequencyInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    })

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-cancelled"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedPlan = 'annual';
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const savingsPercent = Math.round(
      ((productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price) /
      (productConfigs.plus.seasonal.price * 4)) * 100
    );
    const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
      if (bullet.classList.contains('hide-lite')) {
        bullet.style.display = 'block';
      }

      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
      }
    });


    const config = productConfigs.plus[selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs.plus.seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs.plus.annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs.plus.annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price}`;

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();

  function toggleAccordion(button) {
    const accordionItem = button.parentElement;
    const isActive = accordionItem.classList.contains('active');
    const accordionSection = accordionItem.closest('.accordion-section, .accordion.subscription-accordion');

    if (accordionSection) {
      accordionSection.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('active');
      });
    } else {
      document.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('active');
      });
    }

    if (!isActive) {
      accordionItem.classList.add('active');
    }
  }

  window.toggleAccordion = toggleAccordion;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-checkout"]) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    if (selectedBoxType == 'regular') {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      });
    } else {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      });
    }

    const config = productConfigs[selectedBoxType][selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-figma"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');
  const purchaseTypeInputs = document.querySelectorAll('input[name="purchase-type"]');
  const step2Container = document.querySelector('.step-2-container');
  const step3Container = document.querySelector('.step-3-container');
  const giftCheckbox = document.querySelector('#gift-purchase');
  const giftFormContainer = document.querySelector('.gift-form-container');
  const giftSeasonInputs = document.querySelectorAll('input[name="gift-seasons"]');

  function updateStep3Visibility() {
    // If Step 2 doesn't exist, always show Step 3 (it becomes Step 2)
    if (!step2Container) {
      step3Container.classList.add('show');
      return;
    }
    
    const subscriptionSelected = document.querySelector('input[name="purchase-type"]#subscription:checked');
    if (subscriptionSelected) {
      step3Container.classList.add('show');
    } else {
      step3Container.classList.remove('show');
    }
  }

  function updateGiftPricing() {
    // If gift section doesn't exist (Step 2 is hidden), skip gift pricing updates
    if (!giftFormContainer) {
      return;
    }
    
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const boxTypeKey = selectedBoxType === 'plus' ? 'plus' : 'regular';
    
    // Get the one-season base price for strikethrough calculations
    const oneSeasonPrice = parseFloat(productConfigs.gift[boxTypeKey]['1'].price);
    
    // Update 1 Season pricing
    const price1 = parseFloat(productConfigs.gift[boxTypeKey]['1'].price);
    const giftPrice1 = document.querySelector('.gift-price-1');
    if (giftPrice1) {
      giftPrice1.innerHTML = '<strong>$' + Math.round(price1) + '/box</strong>';
    }
    
    // Update 2 Seasons pricing
    const price2 = parseFloat(productConfigs.gift[boxTypeKey]['2'].price);
    const strikethrough2 = Math.round(oneSeasonPrice * 2);
    const giftStrikethrough2 = document.querySelector('.gift-strikethrough-2');
    const giftPrice2 = document.querySelector('.gift-price-2');
    const giftPerBox2 = document.querySelector('.gift-per-box-2');
    if (giftStrikethrough2) giftStrikethrough2.innerHTML = '$' + strikethrough2;
    if (giftPrice2) giftPrice2.innerHTML = '<strong>$' + Math.round(price2) + '</strong>';
    if (giftPerBox2) giftPerBox2.innerHTML = '($' + (price2 / 2).toFixed(2) + '/box)';
    
    // Update 3 Seasons pricing
    const price3 = parseFloat(productConfigs.gift[boxTypeKey]['3'].price);
    const strikethrough3 = Math.round(oneSeasonPrice * 3);
    const giftStrikethrough3 = document.querySelector('.gift-strikethrough-3');
    const giftPrice3 = document.querySelector('.gift-price-3');
    const giftPerBox3 = document.querySelector('.gift-per-box-3');
    if (giftStrikethrough3) giftStrikethrough3.innerHTML = '$' + strikethrough3;
    if (giftPrice3) giftPrice3.innerHTML = '<strong>$' + Math.round(price3) + '</strong>';
    if (giftPerBox3) giftPerBox3.innerHTML = '($' + (price3 / 3).toFixed(2) + '/box)';
    
    // Update 4 Seasons pricing
    const price4 = parseFloat(productConfigs.gift[boxTypeKey]['4'].price);
    const strikethrough4 = Math.round(oneSeasonPrice * 4);
    const giftStrikethrough4 = document.querySelector('.gift-strikethrough-4');
    const giftPrice4 = document.querySelector('.gift-price-4');
    const giftPerBox4 = document.querySelector('.gift-per-box-4');
    if (giftStrikethrough4) giftStrikethrough4.innerHTML = '$' + strikethrough4;
    if (giftPrice4) giftPrice4.innerHTML = '<strong>$' + Math.round(price4) + '</strong>';
    if (giftPerBox4) giftPerBox4.innerHTML = '($' + (price4 / 4).toFixed(2) + '/box)';
  }

  function updateGiftFormVisibility() {
    const checkoutButton = document.querySelector('#main-checkout-btn');
    
    // If gift checkbox doesn't exist (Step 2 is hidden), skip gift logic
    if (!giftCheckbox || !giftFormContainer) {
      return;
    }
    
    if (giftCheckbox.checked) {
      giftFormContainer.classList.add('show');
      // Set data-type to trigger gift handling in custom.js
      checkoutButton.setAttribute('data-type', 'gift-card');
      // Hide Step 2 and Step 3 when it's a gift
      if (step2Container) {
        step2Container.classList.add('hide');
      }
      step3Container.classList.remove('show');
      // Attach selected gift seasons to checkout
      const selectedGift = document.querySelector('input[name="gift-seasons"]:checked');
      if (selectedGift) {
        checkoutButton.setAttribute('data-gift-seasons', selectedGift.value);
      }
    } else {
      giftFormContainer.classList.remove('show');
      // Remove data-type attribute for normal purchases
      checkoutButton.removeAttribute('data-type');
      checkoutButton.removeAttribute('data-gift-seasons');
      // Show Step 2 when not a gift (if it exists)
      if (step2Container) {
        step2Container.classList.remove('hide');
      }
      // Re-evaluate Step 3 visibility based on current purchase selection
      updateStep3Visibility();
    }
  }

  // Keep checkout button in sync with gift seasons selection
  giftSeasonInputs.forEach((input) => {
    input.addEventListener('change', () => {
      if (giftCheckbox && giftCheckbox.checked) {
        checkoutButton.setAttribute('data-gift-seasons', input.value);
        // Also update pricing/variant selection when seasons change
        updateCheckoutButton();
      }
    });
  });

  function showFieldError(inputEl, message) {
    const field = inputEl.closest('.form-field');
    if (!field) return;
    field.classList.add('error');
    let error = field.querySelector('.error-text');
    if (!error) {
      error = document.createElement('div');
      error.className = 'error-text';
      field.appendChild(error);
    }
    error.textContent = message;
  }

  function clearFieldError(inputEl) {
    const field = inputEl.closest('.form-field');
    if (!field) return;
    field.classList.remove('error');
    const error = field.querySelector('.error-text');
    if (error) error.remove();
  }

  function clearGiftErrors() {
    ['email', 'first_name', 'last_name', 'sender'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) clearFieldError(el);
    });
  }

  function validateGiftForm() {
    let isValid = true;
    const email = document.getElementById('email');
    const firstName = document.getElementById('first_name');
    const lastName = document.getElementById('last_name');
    const sender = document.getElementById('sender');

    if (email) {
      const value = email.value.trim();
      if (!value || !email.checkValidity()) {
        showFieldError(email, 'Enter a valid recipient email');
        isValid = false;
      } else {
        clearFieldError(email);
      }
    }

    if (firstName) {
      const value = firstName.value.trim();
      if (!value) {
        showFieldError(firstName, 'Recipient first name is required');
        isValid = false;
      } else {
        clearFieldError(firstName);
      }
    }

    if (lastName) {
      const value = lastName.value.trim();
      if (!value) {
        showFieldError(lastName, 'Recipient last name is required');
        isValid = false;
      } else {
        clearFieldError(lastName);
      }
    }

    if (sender) {
      const value = sender.value.trim();
      if (!value) {
        showFieldError(sender, 'Your name is required');
        isValid = false;
      } else {
        clearFieldError(sender);
      }
    }

    return isValid;
  }

  // Live-clear errors as user types
  ['email', 'first_name', 'last_name', 'sender', 'message'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', () => clearFieldError(el));
    }
  });

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlanInput = document.querySelector('input[name="seasonal-annual"]:checked');
    const selectedPlan = selectedPlanInput ? selectedPlanInput.id : 'seasonal';
    const purchaseTypeSelected = document.querySelector('input[name="purchase-type"]:checked');
    // Default to subscription if no purchase type is selected (e.g., when Step 2 is hidden)
    const purchaseType = purchaseTypeSelected ? purchaseTypeSelected.id : 'subscription';
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually');
    const dynamicStartingPrice = document.querySelector('.dynamic-starting-price');

    const savingsPercent = Math.round(
      ((productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price) /
      (productConfigs[selectedBoxType].seasonal.price * 4)) * 100
    );
    const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      if (selectedBoxType === 'regular') {
        bullet.innerHTML = bullet.innerHTML.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      } else {
        bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      }

      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
      }
    });


    let config;
    if (giftCheckbox && giftCheckbox.checked) {
      const selectedGift = document.querySelector('input[name="gift-seasons"]:checked');
      const selectedGiftKey = selectedGift ? selectedGift.value : '1';
      const boxTypeKey = selectedBoxType === 'plus' ? 'plus' : 'regular';
      config = productConfigs.gift[boxTypeKey][selectedGiftKey];
      checkoutButton.setAttribute('data-variant-id', config.variantId);
      if (config.sellingPlanId) {
        checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);
      } else {
        checkoutButton.removeAttribute('data-selling-plan-id');
      }
      checkoutButton.setAttribute('data-qty', '1');
    } else if (purchaseType === 'one-time') {
      config = productConfigs[selectedBoxType].one_time;
      checkoutButton.setAttribute('data-variant-id', config.variantId);
      checkoutButton.removeAttribute('data-selling-plan-id');
      checkoutButton.setAttribute('data-qty', '1');
    } else {
      config = productConfigs[selectedBoxType][selectedPlan];
      checkoutButton.setAttribute('data-variant-id', config.variantId);
      checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);
      checkoutButton.setAttribute('data-qty', '1');
    }

    const price = config.price;

    // Update Step 3 prices when it's a subscription OR when Step 2 is hidden (Step 3 becomes Step 2)
    // When Step 2 is hidden, always show subscription pricing since that's the only option
    const shouldUpdatePrices = (!step2Container) || 
                                ((!giftCheckbox || !giftCheckbox.checked) && purchaseType === 'subscription');
    
    if (shouldUpdatePrices) {
      // Update Step 3 plan prices (seasonal and annual)
      if (seasonalPrice && annualPrice && billedAnnually && savings) {
        seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
        annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
        savings.innerText = '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);
      }
      
      // Update Step 2 dynamic starting price (only exists when Step 2 is visible)
      if (dynamicStartingPrice) {
        const cheapestAnnualPrice = parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2);
        dynamicStartingPrice.innerHTML = '$' + cheapestAnnualPrice + '/box';
      }
    }

    // Update one-time purchase price based on selected box type
    const dynamicOnetimePrice = document.querySelector('.dynamic-onetime-price');
    if (dynamicOnetimePrice) {
      const onetimePrice = productConfigs[selectedBoxType].one_time.price;
      dynamicOnetimePrice.innerHTML = '$' + onetimePrice + '/box';
    }

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;
  }

  // Set up event listeners once (outside of updateCheckoutButton to prevent duplicate listeners)
  boxTypeInputs.forEach((input) => {
    input.addEventListener('change', () => {
      updateCheckoutButton();
      updateGiftPricing();
    });
  });

  planInputs.forEach((input) => {
    input.addEventListener('change', updateCheckoutButton);
  });

  purchaseTypeInputs.forEach((input) => {
    input.addEventListener('change', () => {
      updateStep3Visibility();
      updateCheckoutButton();
    });
  });

  if (giftCheckbox) {
    giftCheckbox.addEventListener('change', () => {
      updateGiftFormVisibility();
      updateCheckoutButton();
      if (!giftCheckbox.checked) {
        clearGiftErrors();
      }
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight + 250)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 250) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  // Show Step 3 first if Step 2 is hidden, then update prices
  updateStep3Visibility();
  updateCheckoutButton();
  updateGiftFormVisibility();
  updateGiftPricing();

  // Intercept checkout click to validate gift form when gift purchase is selected
  if (checkoutButton) {
    checkoutButton.addEventListener('click', (e) => {
      if (giftCheckbox && giftCheckbox.checked) {
        if (!validateGiftForm()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          // Scroll to top of gift form for visibility
          const form = document.querySelector('.gift-form-container');
          if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      }
      return true;
    });
  }

  // Capture-phase guard to block any other listeners from adding to cart
  document.addEventListener('click', (e) => {
    const btn = e.target && (e.target.closest && e.target.closest('#main-checkout-btn'));
    if (!btn) return;
    if (giftCheckbox && giftCheckbox.checked && !validateGiftForm()) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const form = document.querySelector('.gift-form-container');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  function toggleAccordion(button) {
    const accordionItem = button.parentElement;
    const isActive = accordionItem.classList.contains('active');
    
    // Close all accordion items
    document.querySelectorAll('.accordion-item').forEach(item => {
      item.classList.remove('active');
    });
    
    // If this item wasn't active, open it
    if (!isActive) {
      accordionItem.classList.add('active');
    }
  }

  // Make toggleAccordion globally available
  window.toggleAccordion = toggleAccordion;

  const modal = document.getElementById('modal');
  const modalBody = document.getElementById('modal-body');
  const modalBtn = document.getElementById('open-modal');
  const closeModal = document.getElementById('close-button');

  modalBtn.addEventListener('click', () => {
    modalBody.innerHTML = `
      <div class="loader"></div>
      <p style="text-align:center;">Loading content...</p>
    `;
    modal.style.display = "block";
    
    fetch(nowShippingModalLink)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const targetDiv = doc.querySelector('main.main-content');

        modalBody.innerHTML = targetDiv ? targetDiv.innerHTML : "<p style='text-align:center;'>Content not found</p>";
      })
      .catch(() => {
        modalBody.innerHTML = "<p style='color:red; text-align:center;'>Failed to load content.</p>";
      })
  });

  closeModal.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  window.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-gilt"]) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    if (selectedBoxType == 'regular') {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      });
    } else {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      });
    }

    const config = productConfigs[selectedBoxType][selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    // checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;
    checkoutButton.innerHTML = `${ctaText} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-only-plan-selected"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedPlanInput = document.querySelector('input[name="seasonal-annual"]:checked');
    const selectedPlan = selectedPlanInput ? selectedPlanInput.id : 'seasonal';
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually');

    const savingsPercent = Math.round(
      ((productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price) /
      (productConfigs.plus.seasonal.price * 4)) * 100
    );

    // Round to nearest 5%
    // const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      // Check if bullet has the attribute OR contains a percentage pattern
      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${savingsPercent}%`);
      }
    });

    const config = productConfigs.plus[selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);
    checkoutButton.setAttribute('data-qty', '1');

    const price = config.price;

    // Update plan prices
    if (seasonalPrice && annualPrice && billedAnnually && savings) {
      seasonalPrice.innerHTML = '$' + productConfigs.plus.seasonal.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs.plus.annual.price / 4.00).toFixed(2) + '<span> / box</span>';
      billedAnnually.innerText = 'Billed $' + parseInt(productConfigs.plus.annual.price) + ' annually.';
      savings.innerText = '$' + (productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price);
    }
    checkoutButton.innerHTML = `${ctaText} - $${price}`;
  }

  planInputs.forEach((input) => {
    input.addEventListener('change', updateCheckoutButton);
  });

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight + 250)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 250) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();

  function toggleAccordion(button) {
    const accordionItem = button.parentElement;
    const isActive = accordionItem.classList.contains('active');
    
    // Close all accordion items
    document.querySelectorAll('.accordion-item').forEach(item => {
      item.classList.remove('active');
    });
    
    // If this item wasn't active, open it
    if (!isActive) {
      accordionItem.classList.add('active');
    }
  }

  // Make toggleAccordion globally available
  window.toggleAccordion = toggleAccordion;

  const modal = document.getElementById('modal');
  const modalBody = document.getElementById('modal-body');
  const modalBtn = document.getElementById('open-modal');
  const closeModal = document.getElementById('close-button');

  modalBtn.addEventListener('click', () => {
    modalBody.innerHTML = `
      <div class="loader"></div>
      <p style="text-align:center;">Loading content...</p>
    `;
    modal.style.display = "block";
    
    fetch(nowShippingModalLink)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const targetDiv = doc.querySelector('main.main-content');

        modalBody.innerHTML = targetDiv ? targetDiv.innerHTML : "<p style='text-align:center;'>Content not found</p>";
      })
      .catch(() => {
        modalBody.innerHTML = "<p style='color:red; text-align:center;'>Failed to load content.</p>";
      })
  });

  closeModal.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  window.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-only-plan"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedPlanInput = document.querySelector('input[name="seasonal-annual"]:checked');
    const selectedPlan = selectedPlanInput ? selectedPlanInput.id : 'seasonal';
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually');

    const savingsPercent = Math.round(
      ((productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price) /
      (productConfigs.plus.seasonal.price * 4)) * 100
    );

    // Round to nearest 5%
    // const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      // Check if bullet has the attribute OR contains a percentage pattern
      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${savingsPercent}%`);
      }
    });

    const config = productConfigs.plus[selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);
    checkoutButton.setAttribute('data-qty', '1');

    const price = config.price;

    // Update plan prices
    if (seasonalPrice && annualPrice && billedAnnually && savings) {
      seasonalPrice.innerHTML = '$' + productConfigs.plus.seasonal.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs.plus.annual.price / 4.00).toFixed(2) + '<span> / box</span>';
      billedAnnually.innerText = 'Billed $' + parseInt(productConfigs.plus.annual.price) + ' annually.';
      savings.innerText = '$' + (productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price);
    }
    checkoutButton.innerHTML = `${ctaText} - $${price}`;
  }

  planInputs.forEach((input) => {
    input.addEventListener('change', updateCheckoutButton);
  });

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight + 250)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 250) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();

  function toggleAccordion(button) {
    const accordionItem = button.parentElement;
    const isActive = accordionItem.classList.contains('active');
    
    // Close all accordion items
    document.querySelectorAll('.accordion-item').forEach(item => {
      item.classList.remove('active');
    });
    
    // If this item wasn't active, open it
    if (!isActive) {
      accordionItem.classList.add('active');
    }
  }

  // Make toggleAccordion globally available
  window.toggleAccordion = toggleAccordion;

  const modal = document.getElementById('modal');
  const modalBody = document.getElementById('modal-body');
  const modalBtn = document.getElementById('open-modal');
  const closeModal = document.getElementById('close-button');

  modalBtn.addEventListener('click', () => {
    modalBody.innerHTML = `
      <div class="loader"></div>
      <p style="text-align:center;">Loading content...</p>
    `;
    modal.style.display = "block";
    
    fetch(nowShippingModalLink)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const targetDiv = doc.querySelector('main.main-content');

        modalBody.innerHTML = targetDiv ? targetDiv.innerHTML : "<p style='text-align:center;'>Content not found</p>";
      })
      .catch(() => {
        modalBody.innerHTML = "<p style='color:red; text-align:center;'>Failed to load content.</p>";
      })
  });

  closeModal.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  window.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-plus"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const savingsPercent = Math.round(
      ((productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price) /
      (productConfigs.plus.seasonal.price * 4)) * 100
    );
    const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
      if (bullet.classList.contains('hide-lite')) {
        bullet.style.display = 'block';
      }

      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
      }
    });


    const config = productConfigs.plus[selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs.plus.seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs.plus.annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs.plus.annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price}`;

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();

  function toggleAccordion(button) {
    const accordionItem = button.parentElement;
    const isActive = accordionItem.classList.contains('active');
    const accordionSection = accordionItem.closest('.accordion-section, .accordion.subscription-accordion');

    if (accordionSection) {
      accordionSection.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('active');
      });
    } else {
      document.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('active');
      });
    }

    if (!isActive) {
      accordionItem.classList.add('active');
    }
  }

  window.toggleAccordion = toggleAccordion;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-popup"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    if (selectedBoxType == 'regular') {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      });
    } else {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      });
    }

    const config = productConfigs[selectedBoxType][selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-winback"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const savingsPercent = Math.round(
      ((productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price) /
      (productConfigs[selectedBoxType].seasonal.price * 4)) * 100
    );
    const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      if (selectedBoxType === 'regular') {
        bullet.innerHTML = bullet.innerHTML.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      } else {
        bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      }

      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
      }
    });


    const config = productConfigs[selectedBoxType][selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '<s>$169</s> $' + parseInt(productConfigs[selectedBoxType].seasonal.price) + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const savingsPercent = Math.round(
      ((productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price) /
      (productConfigs[selectedBoxType].seasonal.price * 4)) * 100
    );
    const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      if (selectedBoxType === 'regular') {
        bullet.innerHTML = bullet.innerHTML.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      } else {
        bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      }

      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
      }
    });


    const config = productConfigs[selectedBoxType][selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-testimonials"]) return;
  try {
     
    var swiper = new Swiper(".swiper-testimonials", {
        slidesPerView: 1,
        spaceBetween: 100,
        loop: true,
        autoHeight: true,
        navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 3
            },
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-verified-unboxings"]) return;
  try {
     
    const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 8,
        loop: true,
        loopedSlides: 8,
        freeMode: {
            enabled: true,
            momentum: false
        },
        slidesOffsetBefore: -25,
        speed: 5000,
        breakpoints: {
            768: {
                spaceBetween: 16
            }
        }
    };

    var topSwiper = new Swiper(".swiper-unboxings-top", swiperConfig);
    var bottomSwiper = new Swiper(".swiper-unboxings-bottom", {
        ...swiperConfig,
        slidesOffsetBefore: -50,
        breakpoints: {
            768: {
                spaceBetween: 16,
                slidesOffsetBefore: -125
            }
        }
    });
    // Auto-play videos when they enter the viewport (browser autoplay policy blocks off-screen videos)
    (function() {
        function initVideoAutoplay() {
            var videos = document.querySelectorAll('.cr-verified-unboxings video');
            if (!videos.length) return;
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    var v = entry.target;
                    if (entry.isIntersecting) {
                        if (v.paused) { v.play().catch(function(){}); }
                    } else {
                        if (!v.paused) { v.pause(); }
                    }
                });
            }, { threshold: 0.1 });
            videos.forEach(function(v) { observer.observe(v); });
        }
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initVideoAutoplay);
        } else {
            initVideoAutoplay();
        }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  function toggleAccordion(button) {
    const accordionItem = button.parentElement;
    const isActive = accordionItem.classList.contains('active');
    const accordionSection = accordionItem.closest('.accordion');
    
    // Close all accordion items in the same section
    if (accordionSection) {
      accordionSection.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('active');
      });
    } else {
      // Fallback: close all accordion items if no section found
      document.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('active');
      });
    }
    
    // If this item wasn't active, open it
    if (!isActive) {
      accordionItem.classList.add('active');
    }
  }

  // Make toggleAccordion globally available
  window.toggleAccordion = toggleAccordion;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-purchase-main-marked"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const giftCheckbox = document.querySelector('#gift-purchase');
  const giftFormContainer = document.querySelector('.gift-form-container');
  const giftSeasonInputs = document.querySelectorAll('input[name="gift-seasons"]');

  function updateGiftPricing() {
    if (!giftFormContainer) {
      return;
    }
    
    if (!productConfigs.gift) {
      return;
    }
    
    // Get the one-season base price for strikethrough calculations
    const oneSeasonPrice = parseFloat(productConfigs.gift['1'].price);
    
    // Update 1 Season pricing
    const price1 = parseFloat(productConfigs.gift['1'].price);
    const giftPrice1 = document.querySelector('.gift-price-1');
    if (giftPrice1) {
      giftPrice1.innerHTML = '<strong>$' + Math.round(price1) + '/box</strong>';
    }
    
    // Update 2 Seasons pricing
    const price2 = parseFloat(productConfigs.gift['2'].price);
    const strikethrough2 = Math.round(oneSeasonPrice * 2);
    const giftStrikethrough2 = document.querySelector('.gift-strikethrough-2');
    const giftPrice2 = document.querySelector('.gift-price-2');
    const giftPerBox2 = document.querySelector('.gift-per-box-2');
    if (giftStrikethrough2) giftStrikethrough2.innerHTML = '$' + strikethrough2;
    if (giftPrice2) giftPrice2.innerHTML = '<strong>$' + Math.round(price2) + '</strong>';
    if (giftPerBox2) giftPerBox2.innerHTML = ' ($' + (price2 / 2).toFixed(2) + '/box)';
    
    // Update 3 Seasons pricing
    const price3 = parseFloat(productConfigs.gift['3'].price);
    const strikethrough3 = Math.round(oneSeasonPrice * 3);
    const giftStrikethrough3 = document.querySelector('.gift-strikethrough-3');
    const giftPrice3 = document.querySelector('.gift-price-3');
    const giftPerBox3 = document.querySelector('.gift-per-box-3');
    if (giftStrikethrough3) giftStrikethrough3.innerHTML = '$' + strikethrough3;
    if (giftPrice3) giftPrice3.innerHTML = '<strong>$' + Math.round(price3) + '</strong>';
    if (giftPerBox3) giftPerBox3.innerHTML = ' ($' + (price3 / 3).toFixed(2) + '/box)';
    
    // Update 4 Seasons pricing
    const price4 = parseFloat(productConfigs.gift['4'].price);
    const strikethrough4 = Math.round(oneSeasonPrice * 4);
    const giftStrikethrough4 = document.querySelector('.gift-strikethrough-4');
    const giftPrice4 = document.querySelector('.gift-price-4');
    const giftPerBox4 = document.querySelector('.gift-per-box-4');
    if (giftStrikethrough4) giftStrikethrough4.innerHTML = '$' + strikethrough4;
    if (giftPrice4) giftPrice4.innerHTML = '<strong>$' + Math.round(price4) + '</strong>';
    if (giftPerBox4) giftPerBox4.innerHTML = ' ($' + (price4 / 4).toFixed(2) + '/box)';
  }

  function updateGiftFormVisibility() {
    const checkoutButton = document.querySelector('#main-checkout-btn');
    
    if (!giftCheckbox || !giftFormContainer) {
      return;
    }
    
    if (giftCheckbox.checked) {
      giftFormContainer.classList.add('show');
      checkoutButton.setAttribute('data-type', 'gift-card');
      const selectedGift = document.querySelector('input[name="gift-seasons"]:checked');
      if (selectedGift) {
        checkoutButton.setAttribute('data-gift-seasons', selectedGift.value);
      }
    } else {
      giftFormContainer.classList.remove('show');
      checkoutButton.removeAttribute('data-type');
      checkoutButton.removeAttribute('data-gift-seasons');
    }
  }

  function showFieldError(inputEl, message) {
    const field = inputEl.closest('.form-field');
    if (!field) return;
    field.classList.add('error');
    let error = field.querySelector('.error-text');
    if (!error) {
      error = document.createElement('div');
      error.className = 'error-text';
      field.appendChild(error);
    }
    error.textContent = message;
  }

  function clearFieldError(inputEl) {
    const field = inputEl.closest('.form-field');
    if (!field) return;
    field.classList.remove('error');
    const error = field.querySelector('.error-text');
    if (error) error.remove();
  }

  function clearGiftErrors() {
    // No required fields to clear errors for
  }

  function validateGiftForm() {
    // No required fields to validate - message is optional
    return true;
  }

  // Live-clear errors as user types
  ['message'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', () => clearFieldError(el));
    }
  });

  function updateCheckoutButton() {
    const selectedGift = document.querySelector('input[name="gift-seasons"]:checked');
    const selectedGiftKey = selectedGift ? selectedGift.value : '1';
    
    let config;
    if (productConfigs.gift && productConfigs.gift[selectedGiftKey]) {
      config = productConfigs.gift[selectedGiftKey];
      checkoutButton.setAttribute('data-variant-id', config.variantId);
      if (config.sellingPlanId) {
        checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);
      } else {
        checkoutButton.removeAttribute('data-selling-plan-id');
      }
      checkoutButton.setAttribute('data-qty', '1');
    } else {
      return;
    }

    const price = config.price;
    checkoutButton.innerHTML = giftCheckbox.checked ? `${giftCtaText} &#10141;` : `${ctaText} - $${price}`;
  }

  if (giftSeasonInputs.length > 0) {
    giftSeasonInputs.forEach((input) => {
      input.addEventListener('change', () => {
        updateCheckoutButton();
        if (giftCheckbox && giftCheckbox.checked) {
          checkoutButton.setAttribute('data-gift-seasons', input.value);
        }
      });
    });
  }

  if (giftCheckbox) {
    giftCheckbox.addEventListener('change', () => {
      updateGiftFormVisibility();
      updateCheckoutButton();
      if (!giftCheckbox.checked) {
        clearGiftErrors();
      }
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight + 250)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 250) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();
  updateGiftFormVisibility();
  updateGiftPricing();

  // Intercept checkout click to validate gift form when gift purchase is selected
  if (checkoutButton) {
    checkoutButton.addEventListener('click', (e) => {
      if (giftCheckbox && giftCheckbox.checked) {
        if (!validateGiftForm()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          const form = document.querySelector('.gift-form-container');
          if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      }
      return true;
    });
  }

  // Capture-phase guard to block any other listeners from adding to cart
  document.addEventListener('click', (e) => {
    const btn = e.target && (e.target.closest && e.target.closest('#main-checkout-btn'));
    if (!btn) return;
    if (giftCheckbox && giftCheckbox.checked && !validateGiftForm()) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const form = document.querySelector('.gift-form-container');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  function toggleAccordion(button) {
    const accordionItem = button.parentElement;
    const isActive = accordionItem.classList.contains('active');
    
    // Close all accordion items
    document.querySelectorAll('.accordion-item').forEach(item => {
      item.classList.remove('active');
    });
    
    // If this item wasn't active, open it
    if (!isActive) {
      accordionItem.classList.add('active');
    }
  }

  // Make toggleAccordion globally available
  window.toggleAccordion = toggleAccordion;

  const modal = document.getElementById('modal');
  const modalBody = document.getElementById('modal-body');
  const modalBtn = document.getElementById('open-modal');
  const closeModal = document.getElementById('close-button');

  if (modalBtn && modal && modalBody) {
    modalBtn.addEventListener('click', () => {
      modalBody.innerHTML = `
        <div class="loader"></div>
        <p style="text-align:center;">Loading content...</p>
      `;
      modal.style.display = "block";
      
      fetch(nowShippingModalLink)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const targetDiv = doc.querySelector('main.main-content');

          modalBody.innerHTML = targetDiv ? targetDiv.innerHTML : "<p style='text-align:center;'>Content not found</p>";
        })
        .catch(() => {
          modalBody.innerHTML = "<p style='color:red; text-align:center;'>Failed to load content.</p>";
        })
    });

    if (closeModal) {
      closeModal.addEventListener('click', () => {
        modal.style.display = 'none';
      });
    }

    window.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-pdp-main-steps"] && !Shopify.designMode) return;
  try {
    
  const checkoutButton = document.querySelector('.checkout-button');
  const frequencyInputs = document.querySelectorAll('input[name="box-frequency"]');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually');
    const planTitles = document.querySelectorAll('.plan input[type="radio"] + label .plan-title');
    const planDescriptions = document.querySelectorAll('.plan input[type="radio"] + label .plan-description');
    const seasonalBilling = document.querySelector('.plan input[type="radio"]#seasonal + label p:not(.plan-description)');

    // Update plan labels based on frequency
    if (selectedFrequency === 'onetime') {
      planTitles[0].textContent = '4 Boxes';
      planTitles[1].textContent = 'Single Box';
      planDescriptions[0].textContent = 'Prepay for 4 boxes';
      planDescriptions[1].textContent = 'One-time purchase';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed once.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed once.';
      }
    } else {
      planTitles[0].textContent = 'Annual';
      planTitles[1].textContent = 'Seasonal';
      planDescriptions[0].textContent = 'Prepay for 4 boxes & save';
      planDescriptions[1].textContent = 'Pay Per box';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed annually.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed quarterly.';
      }
    }

      const savingsPercent = Math.round(
          ((productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price) /
          (productConfigs[selectedBoxType].seasonal.price * 4)) * 100
      );
      const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
      bullets.forEach((bullet) => {
        if (selectedBoxType === 'regular') {
          bullet.innerHTML = bullet.innerHTML.replace('4-8', '1-3');
          if (bullet.classList.contains('hide-lite')) {
              bullet.style.display = 'none';
          }
        } else {
            bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
                if (bullet.classList.contains('hide-lite')) {
                bullet.style.display = 'block';
            }
        }

        if (bullet.hasAttribute('data-dynamic-savings')) {
            bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
        }
    });

    var consolidatedPlan = selectedPlan;
    if (selectedFrequency === 'onetime') {
      if (selectedPlan === 'seasonal') {
        consolidatedPlan = 'single'
      } else {
        consolidatedPlan = 'four'
      }
    } else {
      consolidatedPlan = selectedPlan;
    }

    const config = productConfigs[selectedBoxType][consolidatedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    if (selectedFrequency === 'onetime') {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].single.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' once.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].single.price * 4 - productConfigs[selectedBoxType].four.price);
      }
    } else {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);
      }
    }

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    frequencyInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    })

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();

  function showStep(stepToShow, stepToHide, event) {
    event.preventDefault();
    stepToShow.style.display = "block";
    setTimeout(() => stepToShow.classList.add('active'), 500);

    if (stepToShow === stepOne) {
      document.querySelector('.step-one').classList.add('active');
    } else {
      document.querySelector('.step-two').classList.add('active');
    }

    stepToHide.classList.remove('active');
    
    setTimeout(() => {
      stepToShow.classList.add('active');
    }, 50);
  }

  const stepOne = document.querySelector('.step-one');
  const stepTwo = document.querySelector('.step-two');

  const nextBtn = document.querySelector('.btn-next');
  const prevBtn = document.querySelector('.btn-prev');

  nextBtn.addEventListener('click', (event) => showStep(stepTwo, stepOne, event));
  prevBtn.addEventListener('click', (event) => showStep(stepOne, stepTwo, event));

  const modal = document.getElementById('modal');
  const modalBody = document.getElementById('modal-body');
  const modalBtn = document.getElementById('open-modal');
  const closeModal = document.getElementById('close-button');

  modalBtn.addEventListener('click', () => {
    modalBody.innerHTML = `
      <div class="loader"></div>
      <p style="text-align:center;">Loading content...</p>
    `;
    modal.style.display = "block";
    
    fetch(nowShippingModalLink)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const targetDiv = doc.querySelector('main.main-content');

        modalBody.innerHTML = targetDiv ? targetDiv.innerHTML : "<p style='text-align:center;'>Content not found</p>";
      })
      .catch(() => {
        modalBody.innerHTML = "<p style='color:red; text-align:center;'>Failed to load content.</p>";
      })
  });

  closeModal.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  window.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-pdp-main"] && !Shopify.designMode) return;
  try {
    
  const checkoutButton = document.querySelector('.checkout-button');
  const frequencyInputs = document.querySelectorAll('input[name="box-frequency"]');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually');
    const planTitles = document.querySelectorAll('.plan input[type="radio"] + label .plan-title');
    const planDescriptions = document.querySelectorAll('.plan input[type="radio"] + label .plan-description');
    const seasonalBilling = document.querySelector('.plan input[type="radio"]#seasonal + label p:not(.plan-description)');

    // Update plan labels based on frequency
    if (selectedFrequency === 'onetime') {
      planTitles[0].textContent = '4 Boxes';
      planTitles[1].textContent = 'Single Box';
      planDescriptions[0].textContent = 'Prepay for 4 boxes';
      planDescriptions[1].textContent = 'One-time purchase';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed once.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed once.';
      }
    } else {
      planTitles[0].textContent = 'Annual';
      planTitles[1].textContent = 'Seasonal';
      planDescriptions[0].textContent = 'Prepay for 4 boxes & save';
      planDescriptions[1].textContent = 'Pay Per box';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed annually.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed quarterly.';
      }
    }

      const savingsPercent = Math.round(
          ((productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price) /
          (productConfigs[selectedBoxType].seasonal.price * 4)) * 100
      );
      const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
      bullets.forEach((bullet) => {
        if (selectedBoxType === 'regular') {
          bullet.innerHTML = bullet.innerHTML.replace('4-8', '1-3');
          if (bullet.classList.contains('hide-lite')) {
              bullet.style.display = 'none';
          }
        } else {
            bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
                if (bullet.classList.contains('hide-lite')) {
                bullet.style.display = 'block';
            }
        }

        if (bullet.hasAttribute('data-dynamic-savings')) {
            bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
        }
    });

    var consolidatedPlan = selectedPlan;
    if (selectedFrequency === 'onetime') {
      if (selectedPlan === 'seasonal') {
        consolidatedPlan = 'single'
      } else {
        consolidatedPlan = 'four'
      }
    } else {
      consolidatedPlan = selectedPlan;
    }

    const config = productConfigs[selectedBoxType][consolidatedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    if (selectedFrequency === 'onetime') {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].single.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' once.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].single.price * 4 - productConfigs[selectedBoxType].four.price);
      }
    } else {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);
      }
    }

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;
  }

  frequencyInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    })

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight) && subscriptionsRect.bottom <= 0) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', updateButtonPosition)

  // updateButtonPosition();
  // updateCheckoutButton();

  const modal = document.getElementById('modal');
  const modalBody = document.getElementById('modal-body');
  const modalBtn = document.getElementById('open-modal');
  const closeModal = document.getElementById('close-button');

  modalBtn.addEventListener('click', () => {
    document.querySelector('body').style.overflow = 'hidden';
    modalBody.innerHTML = `
      <div class="loader"></div>
      <p style="text-align:center;">Loading content...</p>
    `;
    modal.style.display = "block";
    
    fetch(nowShippingModalLink)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const targetDiv = doc.querySelector('main.main-content');

        modalBody.innerHTML = targetDiv ? targetDiv.innerHTML : "<p style='text-align:center;'>Content not found</p>";
      })
      .catch(() => {
        modalBody.innerHTML = "<p style='color:red; text-align:center;'>Failed to load content.</p>";
      })
  });

  closeModal.addEventListener('click', () => {
    document.querySelector('body').style.overflow = 'auto';
    modal.style.display = 'none';
  });

  window.addEventListener('click', (event) => {
    if (event.target === modal) {
      document.querySelector('body').style.overflow = 'auto';
      modal.style.display = 'none';
    }
  });

  function goToStep(stepNumber) {
    const currentStep = document.querySelector('.step.active');

    if (stepNumber === 1) {
      document.querySelectorAll('input[name="box-frequency"]').forEach(input => {
        input.checked = false;
      });
    }

    if (currentStep) {
      currentStep.classList.add('fade-out');
      setTimeout(() => {
        currentStep.classList.remove('active', 'fade-out');
        document.getElementById(`step-${stepNumber}`).classList.add('active');
      }, 300)
    } else {
      document.getElementById(`step-${stepNumber}`).classList.add('active');
    }
  }

  window.goToStep = goToStep;

  document.querySelectorAll('.frequency input').forEach((input) => {
    input.addEventListener('change', function() {
      if (this.checked) {
        goToStep(2);
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["original-updated-box-ui"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const savingsPercent = Math.round(
      ((productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price) /
      (productConfigs.plus.seasonal.price * 4)) * 100
    );
    const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
      if (bullet.classList.contains('hide-lite')) {
        bullet.style.display = 'block';
      }

      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
      }
    });


    const config = productConfigs.plus[selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs.plus.seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs.plus.annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs.plus.annual.price) + ' annually ' + annualBoxesText;
    savings.innerText =
      '$' + (productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price}`;

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  // Store the original button position to avoid issues when it becomes fixed
  let originalButtonTop = null;
  
  function updateButtonPosition() {
    requestAnimationFrame(() => {
      // Store original position on first call or when not sticky
      if (!checkoutButton.classList.contains('is-sticky')) {
        // Get the button's position in the document flow
        const buttonRect = checkoutButton.getBoundingClientRect();
        originalButtonTop = buttonRect.top + window.scrollY;
        if (originalButtonTop !== null && window.scrollY > (originalButtonTop + checkoutButton.offsetHeight)) {
          checkoutButton.classList.add('is-sticky');
        }
      } else {
        if (originalButtonTop !== null && window.scrollY <= originalButtonTop) {
          checkoutButton.classList.remove('is-sticky');
          originalButtonTop = null; // Reset to recalculate on next check
        }
      }
    });
  }
  
  window.addEventListener('scroll', updateButtonPosition, { passive: true })

  updateButtonPosition();
  updateCheckoutButton();

  function toggleAccordion(button) {
    const accordionItem = button.parentElement;
    const isActive = accordionItem.classList.contains('active');
    const accordionSection = accordionItem.closest('.accordion-section, .accordion.subscription-accordion');
    
    // Close all accordion items in the same section
    if (accordionSection) {
      accordionSection.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('active');
      });
    } else {
      // Fallback: close all accordion items if no section found
      document.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('active');
      });
    }

    // If this item wasn't active, open it
    if (!isActive) {
      accordionItem.classList.add('active');
    }
  }

  // Make toggleAccordion globally available
  window.toggleAccordion = toggleAccordion;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"]) return;
  try {
    
    const quizContainer = document.querySelector('.quiz-container');
    const steps = document.querySelectorAll('.step');
    const progressBar = document.querySelector('.progress');
    const result = document.querySelector('.result');
    const answersSummary = document.getElementById('answers-summary');
    let currentStep = 1;
    const totalSteps = steps.length;
    const answers = {};

    // Initialize progress bar
    updateProgress();

    // Add click event for options
    document.querySelectorAll('.option').forEach(option => {
        option.addEventListener('click', function() {
            const stepElement = this.closest('.step');
            const radioInput = this.querySelector('input[type="radio"]');
                    
            // Deselect all options in current step
            stepElement.querySelectorAll('.option').forEach(opt => {
                opt.classList.remove('selected');
            });
                    
            // Select clicked option
            this.classList.add('selected');
            radioInput.checked = true;
                    
            // Enable next button
            stepElement.querySelector('.next-btn').disabled = false;
        });
    });

    // Add click event for next buttons
    document.querySelectorAll('.next-btn').forEach(button => {
        button.addEventListener('click', function() {
            const currentStepElement = this.closest('.step');
            const isTextOnly = currentStepElement.getAttribute('data-text-only') === 'true';
                    
            if (!isTextOnly) {
                const selectedOption = currentStepElement.querySelector('input[type="radio"]:checked');
                        
                if (selectedOption) {
                    answers[`q${currentStep}`] = selectedOption.value;                    
                }
            }
                    
            if (currentStep < totalSteps) {
                currentStep++;
                updateStep();
            } else {
                showResult();
            }
        });
    });

    // Add click event for the universal previous button
    const universalPrevBtn = document.getElementById('universal-prev-btn');
    universalPrevBtn.addEventListener('click', function() {
        if (currentStep > 1) {
            currentStep--;
            updateStep();
        }
    });

    document.querySelector('.restart-btn').addEventListener('click', function() {
        document.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = false;
        });
        document.querySelectorAll('.option').forEach(option => {
            option.classList.remove('selected');
        });
                
        currentStep = 1;
        updateStep();
                
        Object.keys(answers).forEach(key => delete answers[key]);
                
        result.style.display = 'none';
                
        steps[0].classList.add('active');
                
        updateProgress();
    });

    function updateStep() {
        steps.forEach(step => {
            step.classList.remove('active');
        });
        document.querySelector(`[data-step="${currentStep}"]`).classList.add('active');
                
        updateProgress();
                
        // Show or hide the universal previous button
        if (currentStep === 1) {
            universalPrevBtn.style.display = 'none';
        } else {
            universalPrevBtn.style.display = 'block';
        }
        const nextBtn = document.querySelector('.step.active .next-btn');
        const isTextOnly = document.querySelector(`[data-step="${currentStep}"]`).getAttribute('data-text-only') === 'true';
        if (isTextOnly) {
            nextBtn.disabled = false;
        } else {
            nextBtn.disabled = !document.querySelector(`.step.active input[name="q${currentStep}"]:checked`);
        }
    }

    function updateProgress() {
        const progress = ((currentStep - 1) / totalSteps) * 100;
        progressBar.style.width = `${progress}%`;
    }

    function showResult() {
        steps.forEach(step => step.classList.remove('active'));
        result.style.display = 'block';
        
        progressBar.style.width = '100%';
        
        const summary = document.createElement('div');
        summary.style.marginBottom = '20px';
        summary.style.textAlign = 'left';
                
        Object.entries(answers).forEach(([question, answer]) => {
            const p = document.createElement('p');
            p.style.margin = '10px 0';
            p.style.color = '#666';
            p.textContent = `Question ${question.slice(1)}: ${answer}`;
            summary.appendChild(p);
        });
                
        answersSummary.innerHTML = '';
        answersSummary.appendChild(summary);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-accordion-main"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const savingsPercent = Math.round(
      ((productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price) /
      (productConfigs.plus.seasonal.price * 4)) * 100
    );
    const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
      if (bullet.classList.contains('hide-lite')) {
        bullet.style.display = 'block';
      }

      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
      }
    });


    const config = productConfigs.plus[selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs.plus.seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs.plus.annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs.plus.annual.price) + ' annually ' + annualBoxesText;
    savings.innerText =
      '$' + (productConfigs.plus.seasonal.price * 4 - productConfigs.plus.annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    // checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;
    checkoutButton.innerHTML = `${ctaText} - $${price}`;
    // checkoutButton.innerHTML = `${ctaText}`; 

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  // Store the original button position to avoid issues when it becomes fixed
  let originalButtonTop = null;
  
  function updateButtonPosition() {
    requestAnimationFrame(() => {
      // Store original position on first call or when not sticky
      if (!checkoutButton.classList.contains('is-sticky')) {
        // Get the button's position in the document flow
        const buttonRect = checkoutButton.getBoundingClientRect();
        originalButtonTop = buttonRect.top + window.scrollY;
        if (originalButtonTop !== null && window.scrollY > (originalButtonTop + checkoutButton.offsetHeight)) {
          checkoutButton.classList.add('is-sticky');
        }
      } else {
        if (originalButtonTop !== null && window.scrollY <= originalButtonTop) {
          checkoutButton.classList.remove('is-sticky');
          originalButtonTop = null; // Reset to recalculate on next check
        }
      }
    });
  }
  
  window.addEventListener('scroll', updateButtonPosition, { passive: true })

  updateButtonPosition();
  updateCheckoutButton();

  function toggleAccordion(button) {
    const accordionItem = button.parentElement;
    const isActive = accordionItem.classList.contains('active');
    const accordionSection = accordionItem.closest('.accordion-section, .accordion.subscription-accordion');
    
    // Close all accordion items in the same section
    if (accordionSection) {
      accordionSection.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('active');
      });
    } else {
      // Fallback: close all accordion items if no section found
      document.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('active');
      });
    }
    
    // If this item wasn't active, open it
    if (!isActive) {
      accordionItem.classList.add('active');
    }
  }

  // Make toggleAccordion globally available
  window.toggleAccordion = toggleAccordion;


  } catch(e) { console.error(e); }
})();
})();
